import { h, render, Component } from 'preact';
import './new-year-track.scss';
import NewYearAPI from './new-year';

export default class NewYearTrack extends Component {

    constructor(props) {
        super(props);

        this.assetsPath = '../../../NewYearTrack/';
        this.api = new NewYearAPI();
        this.state = {
            showNewYearTrack: false,
            iconButton: '',
            tooltip: '',
            tracks: [],
            playbackIcon: undefined,
            playbackIconLeft: undefined,
            timer: null,
            startDate: null,
            endDate: null
        }
        
        window.addEventListener('visibilitychange', () => {
            if (this.state.showNewYearTrack) {
                if (document.visibilityState == 'visible' && this.state.showNewYearTrack ) {
                    this.setState({
                        timer: setInterval(this.updateTracks, 15000)
                    });
                    this.props.routesService.setRoutesOnMap_ny(
                        this.getTracks(this.state.tracks),
                        {...this.state.playbackIcon},
                        false,
                        {...this.state.playbackIconLeft}
                    );
                } else {
                    clearInterval(this.state.timer);
                    this.props.routesService.clearRoutes_ny();

                    this.setState({
                        timer: null
                    });              
                }  
            }
        }, false);         
    }

    componentDidMount() {
        this.api.getNewYearInfo()
            .then(data => {
                if (!!data) {
                    let startDate = null, endDate = null;
                    if (data.startDate) {
                        startDate = new Date(data.startDate).getTime();
                    }
                    if (data.endDate) {
                        endDate = new Date(data.endDate).getTime();
                    }                    
                    this.setState({
                        buttonIcon: this.assetsPath + data.buttonIcon,
                        buttonInactiveIcon: this.assetsPath + data.buttonInactiveIcon,
                        tooltip: data.tooltip,
                        playbackIcon: {
                            iconUrl: this.assetsPath + data.markerIcon,
                            iconAnchor: [30, 60],
                            iconSize: [59, 60]                           
                        },
                        playbackIconLeft: {
                            iconUrl: this.assetsPath + data.markerIconLeft,
                            iconAnchor: [30, 60],
                            iconSize: [59, 60]                              
                        },
                        startDate: startDate,
                        endDate: endDate
                    });
                }
            });
        
        this.api.getNewYearTracks()
            .then(data => {
                if(!!data) {
                    let arr = [];
                    let i = 0;
                    data.forEach(track => {
                        let newPoints = [];
                        track.points.forEach(point => {
                            newPoints.push({
                                dir: null,
                                dst: null,
                                lat: point.lat,
                                lon: point.lon,
                                speed: null,
                                st: null,
                                tm: point.dt,
                                width: null                                
                            });
                        });
                        arr.push({
                            ...track,
                            points: [...newPoints],
                            color: track.color? track.color : i
                        });
                        if (i < 9) {
                            i++
                        } else i = 0;
                    });

                    this.setState({
                        tracks: arr
                    });
                }
            });
    }

    getTracks = tracks => {
        let currentTime = new Date().getTime();
        let i = 0;
        let j = 0;
        let currentTracks = [{
            points: [],
            color: tracks[i].color
        }];        
        let tm = currentTime;
        while(i < tracks.length && currentTime >= tm) {
            if (tracks[i].points[j]) {
                tm = new Date(tracks[i].points[j].tm).getTime();
                currentTracks[i].points.push({
                    ...tracks[i].points[j]
                });
                j++;
            } else {
                if (j === tracks[i].points.length) {
                    j = 0;
                    i++;
                    if (i < tracks.length) {
                        currentTracks.push({
                            points: [],
                            color: tracks[i].color
                        });
                    }
                } else j++;
            }
        }
        return currentTracks;
    }

    updateTracks = () => {
        this.props.routesService.updateRoutesOnMap_ny(
            this.getTracks(this.state.tracks),
            {...this.state.playbackIcon},
            {...this.state.playbackIconLeft}
        );
    }

    toggleNewYearTrack = () => {
        this.setState({
            showNewYearTrack: !this.state.showNewYearTrack
        });

        if (this.state.showNewYearTrack) {
            this.setState({
                timer: setInterval(this.updateTracks, 15000)
            });
            this.props.routesService.setRoutesOnMap_ny(
                this.getTracks(this.state.tracks),
                {...this.state.playbackIcon},
                true,
                {...this.state.playbackIconLeft}
            );
        } else {
            clearInterval(this.state.timer);
            this.setState({
                timer: null
            });
            this.props.routesService.clearRoutes_ny();
        }
    }

    render () {
        const currenDate = new Date().getTime();
        return <div>
                {
                    this.state.startDate <= currenDate &&
                    this.state.endDate >= currenDate &&
                    <div 
                    class="new-year-button-wrapper" 
                    style={{
                        top: (this.props.options.position.top+300),
                        right: this.props.options.position.right,
                        background: `url(${this.state.showNewYearTrack? this.state.buttonIcon : this.state.buttonInactiveIcon}) no-repeat center center transparent`
                    }}>
                        <button class="new-year-button" onClick={this.toggleNewYearTrack} />
                    </div>
                }
            </div>;
    }
}